import { defineStore } from 'pinia'

interface PaymentDialogState {
  visible: boolean
  defaultTab: 'member' | 'integral' // 默认显示的标签页
}

export const usePaymentStore = defineStore('payment', {
  state: (): PaymentDialogState => ({
    visible: false,
    defaultTab: 'member'
  }),
  actions: {
    openDialog(tab: 'member' | 'integral' = 'member') {
      this.visible = true
      this.defaultTab = tab
    },
    closeDialog() {
      this.visible = false
    }
  }
})